export const MAX_CONTROLS_CHANGED = 20;
export const MAX_POLICIES_CHANGED = 20;
export const CALCULATION_TIME = 1000;
export const CONTROL_ADD_TIME = 1000;
